import axios from 'axios';
import {toast} from "react-toastify";
import toastOptions from "../data/ToastOptions";

let url = '';
let alarm_url = '';

if (window.location.host.includes('localhost') || window.location.host.includes('127.0.0.1') || window.location.host.includes('ngrok')) {
    url = 'http://localhost:3000/tapp';
    alarm_url = 'http://localhost:3002';
} else {
    url = 'https://jet.jace.team/tapp';
    alarm_url = 'https://jace.team';
}

export const alarmUrl = alarm_url

export const baseUrl = url;

export const baseUrlNoTapp = url.replace('/tapp', '');

const network = axios.create({
    baseURL: url,
});

network.defaults.headers['Content-Type'] = 'application/json';
network.defaults.headers['Platform'] = 'pwa';

export const getInstance = () => {
    return network;
};

network.interceptors.request.use(async config => {
    const token = localStorage.getItem('token');

    // if (token) {
    //     const {accessToken, refreshToken} = token;
    //     // const tokenIsValid = isAccessTokenValid(accessToken);
    //
    //     if (tokenIsValid) {
    //         config.headers.Authorization = `Bearer ${accessToken}`;
    //         return config;
    //     }
    //
    //     // const newToken = await updateTokens(refreshToken);
    //     config.headers.Authorization = `Bearer ${newToken}`;
    //     return config;
    // }

    return config;
});

network.interceptors.response.use(
    res => {
        return res;
    },
    async error => {
        console.warn(
            `network error ${error} ${JSON.stringify(error?.response?.data)}`,
        );
        toast.error('Something went wrong. Please try again.', {...toastOptions, toastId: 5})
        if (error && !!error.response && error.response.status === 401) {
            // onAuthFailedListeners.forEach(l => l());
        }
        throw error;
    },
);

export default network;
